const ROUTES = {
  SEARCH: '/search',
  TRACKING: '/tracking/:saleId'
}

export default ROUTES
